import { DSIndigo } from '@olive/fonts'

export default [DSIndigo]
